import { NavigationMenu as BaseNavigationMenu } from "@base-ui-components/react/navigation-menu";

type NavigationMenuItemProps = BaseNavigationMenu.Item.Props;

const NavigationMenuItem = (props: NavigationMenuItemProps) => {
  const { children, className, role = "menuitem", ...rest } = props;
  return (
    <BaseNavigationMenu.Item role={role} {...rest} className={className}>
      {children}
    </BaseNavigationMenu.Item>
  );
};

export default NavigationMenuItem;
